export default
{
    name: 'app-words-fade',

    data()
    {
        return {
            words: []
        }
    },

    props:
    {
        text: { type: String, default: '' },
        centerX: { type: Number, default: 0.5 },
        centerY: { type: Number, default: 0.5 },
        visible: { type: Boolean, default: false },
        distance: { type: Number, default: 60 },
        duration: { type: Number, default: 2 },
        delayMultiplier: { type: Number, default: 0.004 },
        seperateLetters: { type: Boolean, default: false },
        lettersIndexOffset: { type: Number, default: 0 }
    },

    watch:
    {
        visible()
        {
            // Container
            const containerBoundings = this.$el.getBoundingClientRect()
            const containerCenterX = containerBoundings.left + containerBoundings.width * this.centerX
            const containerCenterY = containerBoundings.top + containerBoundings.height * this.centerY

            // Word
            this.$words = this.$refs.words

            for(const $word of this.$words)
            {
                const wordBoundings = $word.getBoundingClientRect()
                const wordCenterX = wordBoundings.left + wordBoundings.width * 0.5
                const wordCenterY = wordBoundings.top + wordBoundings.height * 0.5
                const distance = Math.hypot(wordCenterX - containerCenterX, wordCenterY - containerCenterY)
                const angle = Math.atan2(wordCenterY - containerCenterY, wordCenterX - containerCenterX)
                const wordX = Math.cos(angle) * this.distance
                const wordY = Math.sin(angle) * this.distance
                const delay = Math.round(distance * this.delayMultiplier * 1000)

                $word.style.transform = `translateX(${wordX}px) translateY(${wordY}px)`
                $word.style.opacity = 0

                window.requestAnimationFrame(() =>
                {
                    window.requestAnimationFrame(() =>
                    {
                        $word.style.transitionDelay = `${delay / 1000}s, ${delay / 1000}s`
                        $word.style.transitionDuration = `${this.duration}s, ${this.duration}s`
                        $word.style.transitionTimingFunction = 'cubic-bezier(0, 0, 0, 1), cubic-bezier(0, 0, 0, 1)'
                        $word.style.transform = 'translateX(0px) translateY(0px)'
                        $word.style.opacity = 1
                    })
                })
            }
        }
    },

    created()
    {
        this.letterIndex = 0
        this.words = this.text.replace(/<br ?\/?>/gi, ' <br/> ').split(/\s+/)
    },

    mounted()
    {
    },

    methods:
    {
        getLetterIndex()
        {
            return this.letterIndex++
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-words-fade/script.js